import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(2),
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '600px',
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    color: '#666',
  },
  section: {
    width: '100%',
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#333',
  },
  description: {
    marginBottom: theme.spacing(2),
    color: '#666',
  },
  factorsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  availableFactorsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
  },
  availableFactorCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#f9f9f9',
  },
  addButton: {
    backgroundColor: '#FF4500',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#E63E00',
    },
  },
  backButtonContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(3),
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'center',
  },
}))

export default useStyles
